import { Box, Stack, Typography } from "@mui/material"
import { ThemeContext } from "../../Theme/ThemeContext"
import { useContext } from "react";

export function SignoutButton({...params}){

    const { mode } = useContext(ThemeContext);

    let signoutButtonState = params.signoutButtonState
    let setSignoutButtonState = params.setSignoutButtonState
    let handleClick = params.handleClick

    let lightPaths = ["/icons/icons-light/icon-signout-light-active.svg", "/icons/icons-light/icon-signout-light-default.svg", "/icons/icons-light/icon-signout-light-hover.svg"]
    let darkPaths = ["/icons/icons-dark/icon-signout-dark-active.svg", "/icons/icons-dark/icon-signout-dark-default.svg", "/icons/icons-dark/icon-signout-dark-hover.svg"]
    
    let lightColors = ["#02203B", "#06569D", "#138BF6"]
    let darkColors = ["#138BF6", "#75BCFA", "#D8ECFD"]

    const handleButtonHover = (event) => {
        event.preventDefault()
        setSignoutButtonState('hover')
    }

    const handleButtonMouseOut = (event) => {
        event.preventDefault()
        setSignoutButtonState('default')
    }

    let imagePath = ''
    let labelColor = ''

    if (mode === 'light'){
        if (signoutButtonState === 'active') {imagePath = lightPaths[0]; labelColor = lightColors[0]}
        else if (signoutButtonState === 'default') {imagePath = lightPaths[1]; labelColor = lightColors[1]}
        else if (signoutButtonState === 'hover') {imagePath = lightPaths[2]; labelColor = lightColors[2]}
    } 
    else if (mode === 'dark'){
        if (signoutButtonState === 'active') {imagePath = darkPaths[0]; labelColor = darkColors[0]}
        else if (signoutButtonState === 'default') {imagePath = darkPaths[1]; labelColor = darkColors[1]}
        else if (signoutButtonState === 'hover') {imagePath = darkPaths[2]; labelColor = darkColors[2]}
    } 

    let labelFormatting = params.labelFormatting
    let labelStyling = {color: labelColor, width: '55px', height: '10px'}

    return (
        <Stack width={'71px'} height={'55px'} direction={'column'} alignItems={'center'} zIndex={100}
            onMouseOut={(event) => handleButtonMouseOut(event)} 
            onMouseOver={(event) => handleButtonHover(event)}
            onClick={(event) => handleClick(event)}>

            <Box component="img" src={imagePath} width={'35px'} height={'45px'} paddingBottom={'10px'}  id={"StationsButton"}/>
            <Typography sx={[labelFormatting, labelStyling]}>Sign Out</Typography>
        </Stack>
    )
}
